import * as React from 'react';
import * as cx from 'classnames';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { isCompleted } from 'utils/asyncStatusHelper';
import styles from './FooterContent.css';
class FooterContent extends React.Component {
    renderPricelistWidget(widget) {
        if (!widget || !widget.data || !widget.header)
            return null;
        const { data, header } = widget;
        const answerBoxValue = get(data, 'renderableComponents[0].value');
        const headerTitle = get(header, 'value.titleValue.text', '');
        if (!answerBoxValue)
            return;
        return (<section className={styles['pricelist-widget']}>
				<h2 className={styles['title']}>{headerTitle}</h2>
				<div className={cx(styles['list-item'], styles['header-text'])}>
					<div className={styles['first-item']}>{get(answerBoxValue, ['heading', 'title'])}</div>
					{answerBoxValue.heading.values &&
            answerBoxValue.heading.values.map((heading, index) => (<div key={`k${index}`} className={styles['item-content']}>
								{heading}
							</div>))}
				</div>
				<ol>
					{answerBoxValue.data.map((data, index) => data.url && data.values ? (<li key={`d${index}`} className={styles['list-item']}>
								<div className={styles['first-item']}>
									<Link to={data.url}>{data.title}</Link>
								</div>
								{data.values.map((value, tdindex) => (<div key={`v${tdindex}`} className={styles['item-content']}>
										{value}
									</div>))}
							</li>) : null)}
				</ol>
				<div className={styles['footer-text']}>{answerBoxValue.footer || ''}</div>
			</section>);
    }
    render() {
        const { seoMeta } = this.props;
        const { metadata, answerBox } = seoMeta;
        const seoContent = get(metadata, ['seo', 'content']);
        return (<div className="row">
				<div className={cx('col gu12', styles['about'])}>
					{seoMeta && isCompleted(seoMeta) && seoContent ? (<div className={styles['content']}>
							{this.renderPricelistWidget(answerBox)}
							<div dangerouslySetInnerHTML={{ __html: seoContent }}/>
						</div>) : null}
				</div>
			</div>);
    }
}
function mapStateToProps(state) {
    return {
        seoMeta: state.seoMeta
    };
}
export default connect(mapStateToProps)(FooterContent);
